import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./auth";
import ProtectedRoute from "./ProtectedRoute";
import { Toaster } from "./components/ui/sonner";
import Login from "./pages/Login";
import ForgotPassword from "./pages/ForgotPassword";
import Dashboard from "./pages/Dashboard";
import PositionDetail from "./pages/PositionDetail";
import Analytics from "./pages/Analytics";
import Users from "./pages/Users";
import Masters from "./pages/Masters";
import Reports from "./pages/Reports";
import Profile from "./pages/Profile";
import Layout from "./components/Layout";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route element={<ProtectedRoute><Layout /></ProtectedRoute>}>
              <Route path="/" element={<Dashboard />} />
              <Route path="/positions/:id" element={<PositionDetail />} />
              <Route path="/analytics" element={<Analytics />} />
              <Route path="/users" element={<ProtectedRoute roles={["Admin"]}><Users /></ProtectedRoute>} />
              <Route path="/masters" element={<ProtectedRoute roles={["Admin"]}><Masters /></ProtectedRoute>} />
              <Route path="/reports" element={<Reports />} />
              <Route path="/profile" element={<Profile />} />
            </Route>
          </Routes>
          <Toaster position="top-right" richColors toastOptions={{ style: { zIndex: 1000 } }} className="!z-[1000]" />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
